import Vue from "vue";
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
import Store from "../store";

/**
 * A debounce directive for search input.
 * Example:
 *  <input v-debounce="handlerSearch"/>
 *  or
 *  <input v-debounce="{evt:'handlerSearch',wait:300}"/>
 */

Vue.directive("debounce", {
  bind(el, binding, vnode) {
    el.oninput = e => {
      if (el.__timout__) {
        clearTimeout(el.__timout__);
      }
      let handler = null;
      let wait = 300;
      if (typeof binding.value === "function") {
        handler = binding.value;
      } else {
        handler = vnode.context[binding.value.evt];
        wait = binding.value.wait;
      }
      el.__timout__ = setTimeout(() => {
        handler.call(null, e.target.value);
      }, wait);
    };
  },
  unbind(el) {
    if (el.__timout__) {
      clearTimeout(el.__timout__);
    }
  }
});


Vue.directive("role", {
  inserted(el, binding) {
    const roles = binding.value;
    if (typeof roles === "undefined" || !Array.isArray(roles)) {
      throw new Error(`The role directive requires an array of parameters, but now it is ${typeof value}`);
    }
    const _role = Store.state.role;
    const hasPer = roles.some(role => _role === role)
    if (!hasPer) {
      el.parentNode.removeChild(el);
    }
  }
})


function handleMultipleTip(el) {
  el.firstElementChild.style.height = "24px";
  el.firstElementChild.style.overflow = "hidden";
  let tags = el.firstElementChild.firstElementChild.childNodes
  let count = 0;
  tags.forEach(tag => {
    if (tag.offsetTop > 5) {
      count++;
    }
  });
  el.setAttribute(
    "class",
    `el-select el-select--mini month-select${count > 0 ? " tip" : ""}`
  );
  if (count > 0) {
    el.setAttribute("data-count", `+${count}`);
  } else {
    el.removeAttribute("data-count");
  }
}


Vue.directive("multiple-tip", {
  inserted(el, binding, vnode) {
    el.__resizeListener = () => {
      vnode.context.$nextTick(() => {
        handleMultipleTip(vnode.elm);
      })
    }
    vnode.componentInstance.$on("change", () => {
      vnode.context.$nextTick(() => {
        setTimeout(() => {
          handleMultipleTip(vnode.elm);
        }, 150)
      });
    })
    addResizeListener(el, el.__resizeListener)
  },
  unbind(el) {
    removeResizeListener(el, el.__resizeListener)
  }
})